import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/css/css.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/traversal/parents/parents.js";

export default obj => {
	obj.each(function () {
		const $this = $(this),
			target = $this.data("mirror");
		if (target) {
			$this.on("change", () => {
				const text = $("#" + target);
				if (this.value) {
					text.text(this.type === "password" ? "*".repeat(this.value.length) : this.value).parent().parent().css("display", "");
				} else {
					text.parent().parent().css("display", "none");
				}
			});
		}
	});
}